module.exports = __webpack_public_path__ + "static/media/Oliver Tree - Alien Boy [Lyric Video].8c1daedd.mp3";